<template>
  <el-table-column
    prop="gla_number.value"
    sortable="custom"
    label="Főkönyvi szám"
    show-overflow-tooltip
    min-width="150px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.gla_number">{{ scope.row.gla_number.value }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'gla_number.value',
  };
</script>
